import React from 'react';
import { AddressSection } from './FormComponents';

const StoreAddress = ({handleBlur, formData,errorData, handleChange }) => (
  <div className="card " style={{ borderRadius: 0 }}>
 
    <div style={{padding: "8px 15px 3px 11px"}}>
      <AddressSection 
        prefix="store" 
        formData={formData} 
        handleChange={handleChange} 
      errorData={errorData}
      handleBlur={handleBlur}
      />
    </div>
  </div>
);

export default StoreAddress;